import { RcFile } from 'antd/lib/upload';
import { IFile } from '../model/BookingModel';
import { IFileUpload } from '../model/CommonModel';
import { TWO_HUNDRED_SUCCESS_CODE } from '../utils/app-common';
import { FileUploadRequest, IOriginal } from '../model/OperationModel';
import { IUploadFile } from '../model/PodModel';

export const responseData = <T extends { data: T, statusCode: number }>(response: T) => {
    const { data, statusCode } = response || {}
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
        return data;
    }
}

export const responseStatus = (response: any) => {
    const { statusCode } = response || {}
    return { statusCode };
}

export enum messageEnum {
    ACCOUNT_CREATED_SUCCESSFULLY = 'Account Created Successful ',
    CUSTOMER_BILLING_CREATED_SUCCESSFULLY = 'Customer Billing Created Successful',
    CUSTOMER_ADDRESS_CREATED_SUCCESSFULLY = 'Customer Address Created Successful',
    UPDATE_ADDRESS_SUCCESSFULLY = 'Update Address  Successful',
    UPDATE_BILLING_ADDRESS_SUCCESSFULLY = 'Update Billing Address  Successful',
    CUSTOMER_CREATED_SUCCESSFULLY = 'Customer Created Successful',
    SUB_CUSTOMER_CREATED_SUCCESSFULLY = 'sub-Customer Created Successful',
    ASSIGNED_DRIVER_SUCCESSFULLY = 'Driver Assigned Successful',
    ASSIGNED_DELIVERY_DRIVER_SUCCESSFULLY = 'Delivery Driver Assigned Successful',
    BOOKING_CANCELED = 'Booking Canceled Successful',
    RTO_SUCCESSFUL = 'RTO Successful',
    CUSTOMER_DELETED = 'Customer Deleted Successful',
    ASSIGNED_DELIVERY_SHEET = ' Assigned Delivery Sheet Successful',
    BOOKING_CREATED_SUCCESSFULLY = 'Booking Created Successful',
    FILE_UPLOADED_SUCCESSFULLY = 'File Uploaded Successful',
    ASSIGNED_POD_SUCCESSFULLY = 'POD Submitted Successful',
    MANUAL_WAYBILL_CREATED_SUCCESSFULLY = 'Manual Waybill Created Successfully',
    DEMURRAGE_SAVED_SUCCESSFULLY = 'Demurrage Configuration Saved Successfully',
}


export const UploadFormData = (fileObject: Partial<IFileUpload>) => {
    const { file, fileName, clientId, clientSubId, fileTypeId, subClientId } = fileObject;

    const formData = new FormData();
    file && formData.append('file', file);
    fileName && formData.append('fileName', fileName);
    clientId && formData.append('clientId', clientId);
    fileTypeId && formData.append('fileTypeId', fileTypeId);
    clientSubId && formData.append('clientSubId', clientSubId);
    subClientId && formData.append('subClientId', subClientId);
    const configuration = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return { formData, configuration };
}

export const UploadRangeFormData = (fileObject: Partial<IFileUpload>) => {
    const { file, fileName, clientId, clientSubId, fileTypeId, subClientId } = fileObject;

    const formData = new FormData();
    file && formData.append('file', file);
    fileName && formData.append('fileName', fileName);
    clientId && formData.append('clientId', clientId);
    fileTypeId && formData.append('fileTypeId', fileTypeId);
    clientSubId && formData.append('clientSubId', clientSubId);
    subClientId && formData.append('subClientId', subClientId);
    const configuration = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return { formData, configuration };
}

export const BookingUploadFormData = (fileObject: IFile) => {

    const { fileType, category, files, wayBillNumber, id } = fileObject
    const formData = new FormData();
    files && files?.map((item: any) => formData.append('files', item?.originFileObj));
    id && formData.append('id', id);
    fileType && formData.append('fileType', fileType);
    category && formData.append('category', category);
    wayBillNumber && formData.append('wayBillNumber', wayBillNumber);
    const configuration = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return { formData, configuration };
}

export const UploadPodFileData = (fileObject: Partial<IFileUpload>, isBulkPickUp: boolean = false, isBulkDelivery: boolean = false, original?: IOriginal) => {
    const { file, wayBillNumber, fileFormat, pickupEmployeeId, vehicleId, vehicleTemp, deliveryByEmpId } = fileObject;
    const formData = new FormData();
    const pickUpRequest = {
        pickupEmployeeId,
        vehicleId,
        vehicleTemp
    };
    const deliveryRequest = {
        vehicleId,
        deliveryByEmpId
    }
    file && formData.append('file', file);
    wayBillNumber && formData.append('wayBillNumber', wayBillNumber);
    fileFormat && formData.append('fileFormat', fileFormat);
    original && formData.append('originalFile', String(original?.isOriginal));
    isBulkPickUp && formData.append('pickup', new Blob([
        JSON.stringify(pickUpRequest)
    ], {
        type: "application/json"
    }));
    isBulkDelivery && formData.append('delivery', new Blob([
        JSON.stringify(deliveryRequest)
    ], {
        type: "application/json"
    }));
    const configuration = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return { formData, configuration };
}

export const emptyUploadedFileValue = (e: any) => e.target.value = ''


export const CustomerUploadFormData = (fileObject: IFile) => {

    const { fileType, category, files, wayBillNumber, categoryId, generic } = fileObject
    const formData = new FormData();
    files && files?.map((item: any) => formData.append('files', item?.originFileObj));
    categoryId && formData.append('categoryId', categoryId);
    generic && formData.append('generic', generic);
    fileType && formData.append('fileType', fileType);
    category && formData.append('category', category);
    wayBillNumber && formData.append('wayBillNumber', wayBillNumber);
    const configuration = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return { formData, configuration };
}

export const ReceiptUploadFormData = (fileObject: IFile) => {
    const { fileType, category, files, categoryIdList, generic } = fileObject;
    const formData = new FormData();
    if (files) formData.append('files', files);
    if (categoryIdList && Array.isArray(categoryIdList)) categoryIdList.forEach((item: any) => formData.append('categoryIdList[]', item));
    if (generic) formData.append('generic', generic);
    if (fileType) formData.append('fileType', fileType);
    if (category) formData.append('category', category);

    const configuration = {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    };
    return { formData, configuration };
};


export const MultiUploadPodFileData = (file: RcFile, isOriginal: boolean) => {
    const { name, type } = file;
    const formData = new FormData();

    file && formData.append('file', file);
    formData.append('wayBillNumber', extractWaybillNumber(name));
    formData.append('fileFormat', type);
    formData.append('originalFile', String(isOriginal));

    const configuration = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return { formData, configuration };
}

export const UploadBarcodePodFileData = (data: IUploadFile) => {
    const { category, file, podBarcodeId } = data
    const { type } = file;
    const formData = new FormData();

    file && formData.append('file', file);
    formData.append('fileFormat', type);
    formData.append('category', category);
    formData.append('podBarcodeId', podBarcodeId);

    const configuration = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return { formData, configuration };
}


const extractWaybillNumber = (inputString) => {
    // Use a regular expression to match the waybill number pattern
    const waybillPattern = /\bA\d{10}\b/;
    const match = inputString.match(waybillPattern);
    return match ? match[0] : '';
}

export const MultiUploadCostModuleFileData = (file: FileUploadRequest) => {
    const formData = new FormData();

    // Append files array to formData
    file.files.forEach((fileItem, index) => {
        formData.append(`files[${index}]`, fileItem);
    });

    // Append other properties to formData
    formData.append('category', file.category);
    formData.append('fileType', file.fileType);
    formData.append('categoryId', file.categoryId);
    formData.append('generic', file.generic.toString());
    if (file.wayBillNumber) {
        formData.append('wayBillNumber', file.wayBillNumber);
    }

    const configuration = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return { formData, configuration };
}


export const UploadCnDnFileData = (fileObject: Partial<IFileUpload>) => {
    const { file, wayBillNumber, fileFormat, generic, fileType, category } = fileObject;
    const formData = new FormData();
    file && formData.append('files', file);
    generic && formData.append('generic', generic);
    fileType && formData.append('fileType', fileType);
    category && formData.append('category', category);
    wayBillNumber && formData.append('wayBillNumber', wayBillNumber);
    fileFormat && formData.append('fileFormat', fileFormat);
    const configuration = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return { formData, configuration };
}